import React, { Component } from 'react';
import _ from 'lodash';
import axios from 'axios';

import Permission from '../../components/Permission';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { MergeAttributes } from '../../components/FlatData';
import Loading from '../../components/Loading';
import AfterSaveLoading from '../../components/AfterSaveLoading';

import UserStore from '../../stores/UserStore';
import './stylesheets/SettingSignaturePage.css';

class SettingSignaturePage extends Component {
	constructor(){
	    super();

	    this.state = {
	    	isDataFetched: false,
	    	users: [],
	    	loading: false,
	    	pagination: {},
      	searchText: ''
	    }

	    this.reload = this.reload.bind(this);
	    this.showSignatureImg = this.showSignatureImg.bind(this);
	    this.handleChangeSignature = this.handleChangeSignature.bind(this);
	    this.actionsFormatter = this.actionsFormatter.bind(this);
	    this.handleDownload = this.handleDownload.bind(this);

	    this.handlePageChange = this.handlePageChange.bind(this);
    	this.handleSearchChange = this.handleSearchChange.bind(this);
	}

	componentDidMount(){
		if (!Permission.isAdmin()) {
			window.location.href = '/documents/mydoc';
		}else{
			this.reload();
		}
	}

	reload(){
		const active_page = this.state.pagination.active_page || 1;
    const { searchText } = this.state;

		UserStore.request({url: `users?page=${active_page}&searchText=${searchText}`}).then((resp)=>{
			const users = _.get(resp.data, 'data', []);
			const pagination = _.get(resp.data, 'meta.pagination', {});

			this.setState({
				users: users,
				pagination: pagination,
				isDataFetched: true
			})
		}).then(()=>{
			this.setState({loading: false});
		});
	}

	handleChangeSignature(user, event){
		var file = event.target.files[0];
    	if (file.size === 0) { return }

    	this.setState({loading: true});
    	var data = new FormData();
    	data.append('user[signature]', file);

    	UserStore.save(user.id, data).then(()=>{
    		this.reload();
		}, function(error){
			this.setState({loading: false});
			var error_message = _.get(error.response.data, 'error.message', '');
			alert(error_message);
		});
	}

	actionsFormatter(cell, row){
		return (
			<div>
	  			<label className="btn btn-sm btn-success pointer mb-0 mr-2">
				    เปลี่ยน
				    <input 
				    	type="file"
				    	name='signature' 
				    	hidden
				    	onChange={this.handleChangeSignature.bind(this, row)} />
				</label>
	  		</div>
		)
	}

	showSignatureImg(cell, row){
		var signature = null;
		if (!_.isEmpty(row.signature)){
			signature = row.signature;
		}
		return (
			<img alt='' src={signature} style={{maxHeight: '60px'}} />
		)
	}

	_setTableOption(){ 
     	if(this.state.isDataFetched){
           	return "Not found";
      	}else{
            return <Loading />
      	}
	}

	handleDownload(){
		axios({
      method:'GET',
      url: '/api/v1/users/no_signature_users',
      responseType:'arraybuffer',
      cache: false,
      data: {
        response_type: 'csv'
      }
    }).then(function(response) {
      let blob = new Blob([response.data], { type: 'application/vnd.ms-excel' } )
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'รายชื่อคนที่ยังไม่มีลายเซ็น.csv'
      link.click()
    });
	}

  handlePageChange(page, sizePerPage){
    this.setState({isDataFetched: false, users: []});
    const { searchText } = this.state;

    UserStore.request({url: `users?page=${page}&searchText=${searchText}`}).then((resp)=>{
      const users = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        users: users,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    })
  }

  handleSearchChange(searchText){
    if (searchText.length === 1) { return }
    this.setState({isDataFetched: false, users: []});

    UserStore.request({url: `users?page=1&searchText=${searchText}`}).then((resp)=>{
      const users = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        users: users,
        pagination: pagination,
        searchText: searchText
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    })
  }

  render(){
  	const total_items_count = _.get(this.state.pagination, 'total_items_count', 0);
    const active_page = _.get(this.state.pagination, 'active_page', 1);

  	var data = MergeAttributes(this.state.users);
		const options = {
	      	sizePerPageList: [],
	      	sizePerPage: 10,
	      	noDataText: this._setTableOption(),
	      	page: active_page,
		      onPageChange: this.handlePageChange,
		      onSearchChange: this.handleSearchChange,
		      searchDelayTime: 500
	    };
		return (
			<div>
				{this.state.loading && <AfterSaveLoading />}

				<div className='row'>
					<div className='col-6'>
						<h3>จัดการลายมือชื่อ</h3>
					</div>
					<div className='col-6 text-right'>
						<button type='button' className='btn btn-info' onClick={this.handleDownload}>
							Download รายชื่อคนที่ยังไม่มีลายเซ็น
						</button>
					</div>
				</div>
				
				<div className="rui-signature-setting">
					<BootstrapTable 
						data={data}
						remote={ true }
        		fetchInfo={{dataTotalSize: total_items_count}}
						search={ true }
						multiColumnSearch={ true }
						options={options}
						striped
						hover
						condensed
						pagination
						version='4'
						tableContainerClass={'table-sm'}>
							<TableHeaderColumn isKey dataField='id' hidden></TableHeaderColumn>
							<TableHeaderColumn dataField='full_name' dataSort={ true }>ชื่อ-นามสกุล</TableHeaderColumn>
							<TableHeaderColumn dataField='position_names' dataSort={ true }>ตำแหน่ง</TableHeaderColumn>
							<TableHeaderColumn dataField='department_names' dataSort={ true }>สาขา</TableHeaderColumn>
							<TableHeaderColumn dataField='id' dataFormat={ this.showSignatureImg } columnClassName='text-md-center'>ลายมือชื่อ</TableHeaderColumn>
							<TableHeaderColumn dataField='id' dataFormat={ this.actionsFormatter } columnClassName='text-md-center'></TableHeaderColumn>
					</BootstrapTable>
				</div>
		  </div>
		)
	}
}

export default SettingSignaturePage;


// WEBPACK FOOTER //
// ./src/pages/settings/SettingSignaturePage.js